<template>
  <div class="p-system-status">
    <page-title>System Status</page-title>

    <tabs v-if="!$route.meta.isAdmin">
      <tabs-item :key="tabs.indexOf(tab)" v-for="tab in tabs" :link="tab.link">
        <icon name="view" v-if="tab.title == 'Following'" />
        {{ " " }}{{ tab.title }}
      </tabs-item>
    </tabs>

    <section-block>
      <template slot="header">
        <filter-bar
          resource="systems"
          :search-query="searchQuery"
          show-search
          :search-options="searchOptions"
        ></filter-bar>
      </template>
      <template slot="actions" v-if="$route.meta.isAdmin">
        <base-button
          :primary="true"
          iconBefore="plus-circle"
          @click="onClickAdd"
          >Add System</base-button
        >
      </template>
      <div v-if="!loading">
        <vuetable
          class="c-data-table"
          :fields="table.fields"
          :api-mode="false"
          :data-manager="dataManager"
          pagination-path
          @vuetable:pagination-data="onPaginationData"
          @vuetable:row-clicked="onRowClick"
          ref="systemsTable"
          no-data-template="<br>No external systems were found.<br><br>"
        >
          <template slot="system-status" slot-scope="props">
            <div class="c-data-table__cell-icon">
              <system-icon :system="props.rowData"></system-icon>
            </div>
          </template>

          <template slot="last-updated" slot-scope="props">
            <div
              class="c-data-table__cell-icon"
              v-if="props.rowData.modified_time || props.rowData.created_time"
            >
              {{
                $dayjs(
                  props.rowData.modified_time || props.rowData.created_time
                ).format("DD / MM / YYYY HH:mm:ss")
              }}
            </div>
            <div class="c-data-table__cell-icon" v-else>(Not Applicable)</div>
          </template>

          <template slot="actions" slot-scope="props">
            <div>
              <base-button
                v-if="$route.meta.isAdmin"
                @click="onClickAddStatus(props.rowData.id)"
                >Update Status</base-button
              >
              <base-button
                v-if="$route.meta.isAdmin"
                @click="onClickEdit(props.rowData.id)"
                >Edit</base-button
              >
              <base-button
                v-if="$route.meta.isAdmin"
                danger
                @click="onClickDelete(props.rowData.id)"
                >Delete</base-button
              >
              <base-button
                v-if="!props.rowData.user_favourite && !$route.meta.isAdmin"
                @click="onClickFollow(props.rowData.id)"
                asLink
                class="favourites--inactive"
              >
                <icon name="view" />
              </base-button>
              <base-button
                v-else-if="props.rowData.user_favourite && !$route.meta.isAdmin"
                @click="onClickUnfollow(props.rowData.id)"
                asLink
                class="favourites--active"
              >
                <icon name="view" />
              </base-button>
            </div>
          </template>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </div>
      <loading v-else></loading>
    </section-block>
  </div>
</template>

<script>
// API
import router from "@/router";
import { mapState, mapGetters } from "vuex";
import Pagination from "@/components/pagination";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";

import SystemIcon from "@/components/SystemIcon";

export default {
  name: "system-status",

  props: ["tabFilter"],

  data() {
    return {
      showFollowing: false,
      searchQuery: "",
      table: {
        fields: [
          {
            name: "system-status",
            title: "Status",
            titleClass: "u-ta-center",
            dataClass: "u-ta-center",
          },
          {
            name: "name",
            title: "System",
            titleClass: "u-ta-left",
          },
          {
            name: "last-updated",
            title: "Last Updated",
            titleClass: "u-ta-left u-hide-mobile",
          },
          {
            name: "actions",
            title: "Actions",
            titleClass: "u-ta-center",
            dataClass: "u-ta-center",
          },
        ],
      },
      tabs: [
        {
          link: "/system-status",
          title: "All Systems",
        },
        {
          link: "/system-status/following",
          title: "Following",
          icon: "eye",
        },
      ],
    };
  },

  mounted() {
    if (this.$route.query.search) {
      this.$store.commit("systems/setSearchQuery", this.$route.query.search);
    }
    this.listSystems(true);
  },

  beforeMount() {
    this.$store.commit("systems/setSearchQuery", "");
  },

  methods: {
    updateTable() {
      this.$refs.systemsTable.refresh();
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.systems.pagination,
        data: this.orderedSystems,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.systemsTable;
      let nextPage;
      this.loading = true;

      switch (page) {
        case "next":
          nextPage = ++this.$store.state.systems.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.systems.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.$store
        .dispatch("systems/list", {
          tabFilter: this.tabFilter,
          forceUpdate: true,
          page: nextPage,
        })
        .then((resp) => {
          window.scroll(0, 0);
          tableref.changePage(nextPage);
          this.loading = false;
        });
    },
    //view the status list
    onRowClick(row) {
      if (
        !this.$route.meta.isAdmin &&
        (row.event.target.localName === "td" ||
          row.event.target.parentNode.localName === "td")
      ) {
        this.$router.push({ name: "ViewStatus", params: { id: row.data.id } });
      }
    },
    onClickDelete(id) {
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store.dispatch("systems/delete", id).then((resp) => {
            this.listSystems();
          });
        },
      });
    },
    onClickAddStatus(id) {
      this.$router.push({ name: "AdminUpdateStatus", params: { id } });
    },
    onClickAdd() {
      this.$router.push({ name: "AdminAddSystem" });
    },
    onClickEdit(id) {
      this.$router.push({ name: "AdminEditSystem", params: { id } });
    },
    listSystems(loading) {
      this.$store.commit("systems/SET_UPDATE_LIST", []);
      this.$store.commit("systems/setSearchQuery", "");
      if (this.$route.query.search) {
        this.$store.commit("systems/setSearchQuery", this.$route.query.search);
      }
      this.$store.dispatch("systems/list", {
        tabFilter: this.tabFilter,
        forceUpdate: true,
      });
    },
    onClickFollow(systemId) {
      this.$store.dispatch("systems/favourite", systemId);
      this.listSystems(false);
    },
    onClickUnfollow(systemId) {
      this.$store.dispatch("systems/unfavourite", systemId);
      this.listSystems(false);
    },
  },

  computed: {
    ...mapGetters("systems", ["orderedSystems"]),
    searchOptions() {
      return { forceUpdate: true, tabFilter: this.tabFilter };
    },
  },

  watch: {
    orderedSystems: {
      immediate: false,
      deep: true,
      handler(newValue, oldValue) {
        this.updateTable();
      },
    },
  },

  components: {
    SystemIcon,
    Pagination,
    VuetablePagination,
  },
};
</script>

<style lang="scss" scoped>
.svg-icon {
  width: 50px;
}
.vuetable-th-slot-last-updated,
/deep/ tr td:nth-child(3) {
  display: none;
  @media (min-width: 768px) {
    display: table-cell;
  }
}

/deep/ .favourites {
  &--inactive {
    svg > path {
      stroke: #425563;
      fill: #425563;
    }
  }

  &--active {
    svg > path {
      stroke: #005eb8;
      fill: #005eb8;
    }
  }
}
</style>
